import React, { SVGProps } from 'react';

const UpdateIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M13.3284 8.02124C13.323 9.37924 12.8077 10.7352 11.7717 11.7712C9.68903 13.8539 6.31169 13.8539 4.22903 11.7712C3.85836 11.4006 3.55703 10.9879 3.31836 10.5506"
      stroke="#000000"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.66992 7.91329C2.69126 6.57729 3.20992 5.24796 4.22926 4.22863C6.31192 2.14596 9.68926 2.14596 11.7719 4.22863C12.1426 4.59929 12.4439 5.01196 12.6826 5.44929"
      stroke="#000000"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6367 5.44998H12.9934V3.09265"
      stroke="#000000"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.36448 10.5499H3.00781V12.9073"
      stroke="#000000"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default UpdateIcon;
